import React, { Component } from "react";
import PureComponent from "../../pure";
import ReportWindowColumnsContainer from "./ReportWindowColumnsContainer";
import  sAction  from "sAction";

import DragAndDrop from "../../dragAndDrop/DragAndDropCoripo";

class ReportWindowColumns extends PureComponent {
  saveColumns(dragData) {
    const prefix = this.props.way
    var data = {
      dragData: dragData,
      wayPrefix: prefix+"/columns/",
    }
    sAction.dragAndDropSave(data);
 

  }
  moveStart(data) {
    const prefix = this.props.way
    const way = data.element.dataset.way;
    sAction.dataSet(prefix+"/columns/" + way + "/def/show", false);
  }
  moveEnd(data) {
    const prefix = this.props.way
    if(data.resize == true){
      const element = data.element;
      const newWidth = element.clientWidth
      const parent = document.querySelector(".columnsLine");
      const parentWidth = parent.clientWidth;
      var percent = (newWidth/parentWidth)*100;
      const way = data.element.dataset.index;
      sAction.dataSet(prefix+"/columns/" + way + "/def/width", percent+"%");
    }else{
    this.saveColumns(data);
    }
  }

  render() {
    const data = this.props.data;
    var hiddenColumns = [];
    var showColumns = [];

    const prefix = this.props.way

    if (data.get("columns") != null) {
      hiddenColumns = data.get("columns").hidden;
      showColumns = data.get("columns").active;
    }
    return (
      <div ref="moveHolder" className="reportWindowColumnsContainer">
        
        <DragAndDrop
          containersClass=".reportWindowColumnsList"
          elementsClass=".reportWindowColumn"
          handleElementClass=".reportWindowColumnSpan"
          wayPrefix={prefix+"/columns/"}
          moveStart={data => this.moveStart(data)}
          moveEnd={data => this.moveEnd(data)}
        >
          <div className="reportWindowColumnsHeaders">
            <h3>{sAction.translate("LBL_REPORT_HIDDEN")}</h3>
            <h3>{sAction.translate("LBL_REPORT_SHOWN")}</h3>
          </div>
          <div className="reportWindowColumnsHeightHolder">
 
            <ReportWindowColumnsContainer
              data={hiddenColumns}
              customClass="reportWindowColumns scrollHeight  columnsHidden"
              moveClass="reportWindowColumnsList"
              containerName={"hidden"}
              withModuleSelect={true}
              activeRelate={data.get("activeRelate")}
              prefix={prefix}
              notAllowedTypes={this.props.notAllowedTypes}
            />
            <ReportWindowColumnsContainer
              data={showColumns}
              customClass="reportWindowColumns scrollHeight  columnsActive"
              moveClass="reportWindowColumnsList"
              modulName={true}
              containerName={"active"}
              setOrder={true}
              setWidth={true}
              prefix={prefix}
            />
          </div>
        </DragAndDrop>
      </div>
    );
  }
}
export default ReportWindowColumns;
